<template>
  <div class="study-task-report">
    <div class="desc" >
      {{ desc }}
    </div>
    <div class="btn">
      <button @click="clickAction">点击查看</button>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { exerReq } from '@/api'
import { Toast } from 'vant'
import app from '@/widget/app'

const props = defineProps({
  desc: {
    type: String,
    default: ""
  },
  id: {
    type: Number,
    default: 0
  }
})

const clickAction = async () => {
  const res = await exerReq.getExerciseReport({
    exerciseId: props.id
  })
  if (Number(res.code) === 200) {
    const data = JSON.stringify(res.data)
    // TODO 学习报告APP 交互
  } else {
    Toast(res.message)
  }
}
</script>

<style lang="scss" scoped>
.study-task-report {
  .desc {
    color: #626366;
    font-size: 28px;
    line-height: 42px;
  }
  .btn {
    text-align: center;
    margin-top: 30px;
    button {
      display: inline-block;
      width: 176px;
      height: 72px;
      border-radius: 36px;
      border: 1px solid #FF6600;
      color: #FF6600;
      font-size: 28px;
      background-color: #fff;
    }
  }
}
</style>
